import React from 'react';
import { MailLogDetailContainerStyled } from './styled';
import { portalService } from 'apiServices';
import { toast } from 'react-toastify';
import { Buttons, Displays } from 'components';
import moment from 'moment';
import 'moment-timezone';
import {
  MAIL_ERROR_HINT,
  RENDER_MAIL_STATUS,
  RENDER_MAIL_TRIGGER,
  RENDER_MAIL_TYPE,
  RENDER_REWARD_TYPE,
} from 'utils/functions/mailLog';

const TIME_ZONE = 'Asia/Bangkok';

const formatDateTime = (date) =>
  date ? moment(date).tz(TIME_ZONE).format('DD/MM/YYYY HH:mm:ss') : '-';

const formatDate = (date) =>
  date ? moment(date).tz(TIME_ZONE).format('DD/MM/YYYY') : '-';

class MailLogDetailContainer extends React.Component {
  state = {
    isLoading: true,
    data: null,
    isConfirmResend: false,
  };

  componentDidMount() {
    this.fetchData();
  }

  fetchData = async () => {
    const { id } = this.props;
    let res = await portalService.GET_MAIL_LOG_BY_ID(id);
    if (res && res.status === 200) {
      this.setState({ data: res.data, isLoading: false });
    } else {
      toast.error('ไม่พบข้อมูล');
      this.setState({ isLoading: false });
    }
  };

  handleResend = async () => {
    const { data } = this.state;
    const { onResent } = this.props;
    if (this.isSubmitting) return;
    this.isSubmitting = true;
    this.setState({ isLoadingBg: true, isConfirmResend: false });
    let res = await portalService.POST_MAIL_LOG_RESEND(data._id);
    this.isSubmitting = false;
    this.setState({ isLoadingBg: false });
    if (res && res.status === 200) {
      if (res.data && res.data.status === 'success') {
        toast.success('ส่งซ้ำสำเร็จ');
      } else {
        toast.error(
          `ส่งซ้ำไม่สำเร็จ: ${
            (res.data && res.data.error_message) || 'ไม่ทราบสาเหตุ'
          }`
        );
      }
      onResent && onResent();
    } else {
      const message =
        (res && res.data && res.data.error && res.data.error.message) ||
        'ส่งซ้ำไม่สำเร็จ';
      toast.error(message);
    }
  };

  renderRow = (label, value) => (
    <div className="info_row">
      <div className="info_label">{label}</div>
      <div className="info_value">
        {value === undefined || value === null || value === '' ? '-' : value}
      </div>
    </div>
  );

  render() {
    const { onClose } = this.props;
    const { isLoading, isLoadingBg, data, isConfirmResend } = this.state;
    const hint = MAIL_ERROR_HINT(data);
    const canResend = data && data.html && data.to && data.to.length > 0;
    const isExpiredType = data && data.type === 'reward_expired';

    return (
      <MailLogDetailContainerStyled>
        <Displays.BGLoading visible={isLoadingBg} />
        <div className="modal_head">
          <div className="modal_title">รายละเอียดการส่งเมล</div>
          <div className="close_btn" onClick={onClose}>
            ✕
          </div>
        </div>
        {isLoading ? (
          <Displays.Loading theme_standard_loading heightLayout="300px" />
        ) : !data ? (
          <div className="empty">ไม่พบข้อมูล</div>
        ) : (
          <>
            <div className="section">
              {this.renderRow(
                'สถานะ',
                <span className={`status_badge status_${data.status}`}>
                  {RENDER_MAIL_STATUS(data.status)}
                </span>
              )}
              {this.renderRow('ประเภท', RENDER_MAIL_TYPE(data.type))}
              {this.renderRow('หัวข้อ', data.subject)}
              {this.renderRow('ผู้ส่ง (From)', data.from)}
              {this.renderRow('ผู้รับ (To)', (data.to || []).join(', '))}
              {data.cc && data.cc.length > 0 &&
                this.renderRow('CC', data.cc.join(', '))}
              {this.renderRow('สร้างเมื่อ', formatDateTime(data.created_at))}
              {this.renderRow('ส่งสำเร็จเมื่อ', formatDateTime(data.sent_at))}
              {this.renderRow(
                'ส่งโดย',
                `${RENDER_MAIL_TRIGGER(data.trigger)}${
                  data.admin_username ? ` (${data.admin_username})` : ''
                }`
              )}
              {data.resend_of_ref_id &&
                this.renderRow('ส่งซ้ำจากรายการ', data.resend_of_ref_id)}
              {this.renderRow('จำนวนของรางวัล', `${data.item_count || 0} รายการ`)}
            </div>

            {(data.status === 'fail' || data.error_message) && (
              <div className="error_box">
                <div className="error_title">สาเหตุที่ส่งไม่สำเร็จ</div>
                <div className="error_message">{data.error_message}</div>
                {(data.error_code || data.error_response_code) && (
                  <div className="error_code">
                    Code: {data.error_code || '-'}
                    {data.error_response_code
                      ? ` / SMTP ${data.error_response_code}`
                      : ''}
                  </div>
                )}
                {hint && <div className="error_hint">แนะนำ: {hint}</div>}
              </div>
            )}

            {data.status === 'success' && (
              <div className="note_box">
                สถานะ "สำเร็จ" หมายถึง Gmail รับเมลไปส่งต่อแล้ว ถ้าผู้รับยังไม่ได้รับ
                ให้ตรวจโฟลเดอร์ Spam / Junk หรือให้ IT ของผู้รับตรวจสอบใน
                mail server / ระบบกรองสแปม
              </div>
            )}

            {data.items && data.items.length > 0 && (
              <div className="section">
                <div className="section_title">รายการของรางวัลที่แจ้งในเมลนี้</div>
                <div className="table_wrap">
                  <table className="item_table">
                    <thead>
                      <tr>
                        <th>No</th>
                        <th>Reward code</th>
                        <th>Reward name</th>
                        <th>Type</th>
                        <th>Expire date</th>
                        <th>{isExpiredType ? 'Status' : 'Days left'}</th>
                        <th className="right">Remaining</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data.items.map((e, i) => (
                        <tr key={i}>
                          <td>{i + 1}</td>
                          <td>{e.reward_code}</td>
                          <td>{e.reward_name}</td>
                          <td>{RENDER_REWARD_TYPE(e.reward_type)}</td>
                          <td>{formatDate(e.expired_at)}</td>
                          <td>
                            {isExpiredType
                              ? 'หมดอายุแล้ว'
                              : e.days_left === 0
                              ? 'วันนี้'
                              : `${e.days_left} วัน`}
                          </td>
                          <td className="right">
                            {Number(e.remain_amount || 0).toLocaleString()}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}

            {data.html && (
              <div className="section">
                <div className="section_title">เนื้อหาเมลที่ส่ง</div>
                {/* sandbox ว่าง = ไม่รัน script ใด ๆ ในเนื้อหาเมล */}
                <iframe
                  className="mail_preview"
                  title="mail preview"
                  sandbox=""
                  srcDoc={data.html}
                />
              </div>
            )}

            <div className="action_zone">
              {isConfirmResend ? (
                <>
                  <div className="confirm_text">
                    ยืนยันส่งเมลฉบับนี้ซ้ำไปที่ {(data.to || []).join(', ')} ?
                  </div>
                  <div className="btn_box">
                    <Buttons.BgStandard
                      label="ยืนยันส่งซ้ำ"
                      onClick={this.handleResend}
                      disabled={isLoadingBg}
                    />
                  </div>
                  <div className="btn_box">
                    <Buttons.BgStandard
                      theme_gray
                      label="ยกเลิก"
                      onClick={() => this.setState({ isConfirmResend: false })}
                    />
                  </div>
                </>
              ) : (
                <>
                  {canResend && (
                    <div className="btn_box">
                      <Buttons.BgStandard
                        label="ส่งซ้ำ"
                        onClick={() => this.setState({ isConfirmResend: true })}
                      />
                    </div>
                  )}
                  <div className="btn_box">
                    <Buttons.BgStandard theme_gray label="ปิด" onClick={onClose} />
                  </div>
                </>
              )}
            </div>
          </>
        )}
      </MailLogDetailContainerStyled>
    );
  }
}

export default MailLogDetailContainer;
